export default __webpack_public_path__ + "static/media/nick-fraser.e95f29ff.png";